import { AnomalyChecker } from './anomaly-checker.interface';
import { MonitoringFailureReason } from '../monitoring-anomaly.model';
import { MonitoringSystemDetail } from '../monitoring-detection.service';

/**
 * Anomaly checker for Google Tag Manager (GTM)
 */
export class GTMAnomalyChecker implements AnomalyChecker {
  readonly key = 'gtm';
  readonly name = 'GTM';

  check(): MonitoringSystemDetail {
    const result: MonitoringSystemDetail = {
      isActive: false,
      scriptLoaded: false,
      lastChecked: Date.now(),
    };

    try {
      if (typeof window === 'undefined') {
        result.failureReason = MonitoringFailureReason.UNKNOWN;
        return result;
      }

      // Check if script tag exists
      const scriptTag = document.querySelector(
        'script[src*="googletagmanager.com/gtm.js"]',
      );
      result.scriptLoaded = scriptTag !== null;

      // Check if dataLayer exists (GTM's global array)
      if ((window as any).dataLayer) {
        // Additional check: verify GTM container is actually loaded
        const gtmLoaded = (window as any).google_tag_manager !== undefined;
        if (gtmLoaded) {
          result.isActive = true;
          return result;
        }

        // Script loaded but not initialized
        result.failureReason = MonitoringFailureReason.NOT_INITIALIZED;
        return result;
      }

      // Determine failure reason
      if (!result.scriptLoaded) {
        result.failureReason = MonitoringFailureReason.NOT_LOADED;
      } else {
        result.failureReason = MonitoringFailureReason.BLOCKED;
      }

      return result;
    } catch (error) {
      console.error(
        `[MonitoringDetection] Error checking ${this.name}:`,
        error,
      );
      result.failureReason = MonitoringFailureReason.UNKNOWN;
      return result;
    }
  }
}
